var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5006 76.3042C56.5941 76.3042 37.957 94.9412 37.957 117.848C37.957 119.612 39.3888 121.044 41.1528 121.044C42.9168 121.044 44.3485 119.611 44.3485 117.847C44.3485 98.4626 60.1158 82.6954 79.5006 82.6954C98.8854 82.6954 114.653 98.4626 114.653 117.847C114.653 119.611 116.084 121.043 117.848 121.043C119.612 121.043 121.044 119.611 121.044 117.847C121.044 94.9412 102.407 76.3042 79.5006 76.3042Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5005 25.1738C67.1654 25.1738 57.1309 35.2081 57.1309 47.5435C57.1309 59.8789 67.1651 69.9131 79.5005 69.9131C91.8359 69.9131 101.87 59.8786 101.87 47.5435C101.87 35.2084 91.8359 25.1738 79.5005 25.1738ZM79.5005 63.5216C70.6934 63.5216 63.5224 56.3506 63.5224 47.5435C63.5224 38.7364 70.6934 31.5653 79.5005 31.5653C88.3076 31.5653 95.4786 38.7364 95.4786 47.5435C95.4786 56.3506 88.3079 63.5216 79.5005 63.5216Z",
    fill: "#ADADAD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 113,
    y: 124,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.d0af69d3af341f7836c8f7a021de0c46.svg";
export { ForwardRef as ReactComponent };